/**
 * Generate a UUID v4
 * @returns {string} A UUID v4 string
 */
export const generateUUID = () => {
  // Use crypto.randomUUID if available (modern browsers)
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback to manual UUID v4 generation
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Generate a user-specific UUID with prefix
 * @returns {string} A UUID with 'user_' prefix
 */
export const generateUserID = () => {
  return `user_${generateUUID()}`;
};

/**
 * Generate a conversation-specific UUID with prefix
 * @returns {string} A UUID with 'conv_' prefix
 */
export const generateConversationID = () => {
  return `conv_${generateUUID()}`;
};

/**
 * Generate a message-specific UUID with prefix
 * @returns {string} A UUID with 'msg_' prefix
 */
export const generateMessageID = () => {
  return `msg_${generateUUID()}`;
};
